/**
 * Reads the `csrf_token` cookie set by the auth backend on /login and /refresh.
 * That cookie is intentionally NOT HttpOnly (unlike refresh_token) — it exists
 * so JS can read it and echo it back as X-CSRF-Token on /refresh and /logout.
 */
export function getCsrfToken(): string | null {
  const match = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

/** Header bag for cookie-authenticated auth endpoints (refresh / logout). */
export function csrfHeaderBag(): Record<string, string> {
  return { 'X-CSRF-Token': getCsrfToken() ?? '' };
}

/**
 * Expire JS-readable auth cookies. HttpOnly `refresh_token` can only be cleared
 * by the server Set-Cookie from POST /auth/logout.
 */
export function clearClientAuthCookies(): void {
  if (typeof document === 'undefined') return;
  const expire = (name: string, path: string) => {
    document.cookie = `${name}=; Path=${path}; Max-Age=0; SameSite=Lax`;
  };
  for (const path of ['/', '/api', '/api/v1', '/api/v1/auth']) {
    expire('csrf_token', path);
  }
}
